import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';
import Container from './styles/Container';

function DateWithCheckbox({ label, value, onChange }) {
  const [checked, setChecked] = useState(Boolean(value));

  useEffect(() => {
    setChecked(Boolean(value));
  }, [value]);

  const handleCheck = (event) => {
    const newValue = event.target.checked;
    setChecked(newValue);

    if (!newValue && value !== null) {
      onChange(null);
    }
  };

  const handleDateChange = (newValue) => {
    onChange(newValue);
  };

  return (
    <Container>
      <FormControlLabel control={<Checkbox checked={checked} onChange={handleCheck} />} label={label} />
      <DatePicker
        value={checked ? value : null}
        onChange={handleDateChange}
        disabled={!checked}
        format="dd.MM.yyyy"
        renderInput={(params) => <TextField {...params} sx={{ width: '200px' }} size="small" />}
      />
    </Container>
  );
}

DateWithCheckbox.propTypes = {
  value: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

DateWithCheckbox.defaultProps = {
  label: '',
};

export default DateWithCheckbox;
